(function($) {

	'use strict';

	var init = function() {

        manageCarousel();
        hideBack();
    };

    var manageCarousel = function() {
        //Attention pour faire fonctionner il faut remplacer dans le code source de owl la fonction suivant par celle juste en dessous : 
        // Owl.prototype.maximum = function (relative) {
        //     var settings = this.settings,
        //         maximum = this._coordinates.length,
        //         iterator,
        //         reciprocalItemsWidth,
        //         elementWidth;
        
        //     if (settings.loop) {
        //         maximum = this._clones.length / 2 + this._items.length - 1;
        //     } else if (settings.center) {
        //         maximum = this._items.length - 1;
        //     } else if (settings.autoWidth || settings.merge) {
        //         iterator = this._items.length;
        //         if (iterator) {
        //             reciprocalItemsWidth = this._items[--iterator].width();
        //             elementWidth = this.$element.width();
        //             while (iterator--) {
        //                 reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
        //                 if (reciprocalItemsWidth > elementWidth) {
        //                     break;
        //                 }
        //             }
        //         }
        //         maximum = iterator + 1;
        //     } else {
        //         maximum = this._items.length - settings.items;
        //     }
        
        //     if (relative) {
        //         maximum -= this._clones.length / 2;
        //     }
        
        //     return Math.max(maximum, 0);
        // };

        $(window).resize(function() {
            if($(window).width() > 767) {
                $('.news__carousel').trigger('destroy.owl.carousel');
                $('.news__carousel').addClass('news__flex');
                $('.news__carousel').removeClass('owl-carousel');
            }else {
                $('.news__carousel').addClass('owl-carousel');
                $('.news__carousel').removeClass('news__flex');
                $('.news__carousel').owlCarousel({
                    center: true,
                    loop: false,
                    items: 1,
                    margin: 20,
                    autoWidth: true
                });
            }
        }).resize();
    };

    var hideBack = function() {
        $(window).scroll(function() {
            if($(window).scrollTop() > ($('.intro').height() + 200)) {
                $('.intro').addClass('hidden');
            } else {
                $('.intro').removeClass('hidden');
            }
        })
    };

	$(document).ready(function() {
		init();
	});

})(jQuery);